import React from "react";
import { graphql, Link } from "gatsby";
import Layout from "../../components/layout";
import { Head as SeoHead } from "../../components/seo";
import { StaticImage } from "gatsby-plugin-image";

const PopularaKattnamn2024Page = ({ data }) => {
  const popularCats = data.allPopularaKattnamn2024Json.nodes;

  // Lägg till bilder och index där de ska visas (index är 1-baserat)
  const images = [
    {
      index: 5,
      element: (
        <StaticImage
          src="../../images/article-content/djur/katter/katt-i-hamn.jpg"
          alt="Katt i hamn"
          layout="constrained"
          formats={["auto", "webp"]}
          width={700}
          loading="eager"
          quality={40}
        />
      ),
    },
    {
      index: 20,
      element: (
        <StaticImage
          src="../../images/article-content/djur/katter/katt-med-guldfisk.jpg"
          alt="Katt i fönster"
          layout="constrained"
          formats={["auto", "webp"]}
          width={700}
          loading="lazy"
          quality={50}
        />
      ),
    },
    
    {
      index: 50,
      element: (
        <StaticImage
          src="../../images/article-content/djur/katter/katt-med-solglasogon.jpg"
          alt="Katt med solglasögon"
          layout="constrained"
          formats={["auto", "webp"]}
          width={700}
          loading="lazy"
        />
      ),
    },
    {
      index: 75,
      element: (
        <StaticImage
          src="../../images/article-content/djur/katter/katter-som-pussas.jpg"
          alt="Katter som pussas"
          layout="constrained"
          formats={["auto", "webp"]}
          width={700}
          loading="lazy"
        />
      ),
    },
    {
      index: 100,
      element: (
        <StaticImage
          src="../../images/article-content/djur/katter/kattunge-pa-sang.jpg"
          alt="Kattunge på säng"
          layout="constrained"
          formats={["auto", "webp"]}
          width={700}
          loading="lazy"
        />
      ),
    },
  ];

  return (
    <Layout>
      <h1>Populära kattnamn 2024</h1>
      <p>Här är en lista över de mest populära kattnamnen i Sverige år 2024.</p>
      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "1rem" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Position</th>
            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Namn</th>
            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Antal</th>
          </tr>
        </thead>
        <tbody>
          {popularCats.map((cat, index) => (
            <React.Fragment key={cat.animalName}>
              <tr>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{index + 1}</td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  <Link to={`/djur/${cat.animalName.toLowerCase()}`}>{cat.animalName}</Link>
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{cat.amount}</td>
              </tr>
              {/* Visa bild efter rätt antal namn, i en egen rad */}
              {images.find((img) => img.index === index + 1) && (
                <tr>
                  <td colSpan={3} style={{ textAlign: "center", padding: "16px 0" }}>
                    {images.find((img) => img.index === index + 1).element}
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      <p>Datakälla: <a href="https://jordbruksverket.se/e-tjanster-databaser-och-appar/e-tjanster-och-databaser-djur/kattregistret/statistik-ur-kattregistret" rel="noopener noreferrer">Jordbruksverket</a>.<br />
      Bildkälla: Unsplash</p>
    </Layout>
  );
};

export const query = graphql`
  query {
    allPopularaKattnamn2024Json {
      nodes {
        animalName
        amount
      }
    }
  }
`;

export const Head = () => (
  <SeoHead
    title="Populära kattnamn 2024"
    description="Se de mest populära kattnamnen i Sverige år 2024. Utforska namnstatistik och trender."
    keywords={["kattnamn", "populära kattnamn", "svenska kattnamn", "djurstatistik", "kattregister"]}
  />
);

export default PopularaKattnamn2024Page;